import React, { useState } from 'react';
import { string, func, bool } from 'prop-types';

import { Specifications } from '@thd-olt-component-react/specifications';
import { extend } from '@thd-nucleus/data-sources';

import { noop } from '../../../../utils/promo-utils';
import { PromoSidecar } from '../../../promo-sidecar/PromoSidecar';
import { PromoQuickviewSectionCta } from '../promo-quickview-section-cta/PromoQuickviewSectionCta';
import '../../PromoQuickview.scss';

export const PromoQuickviewSpecs = ({
  itemId, storeId, onSectionClick, selected, onSelect, setQuantityWarningText, showQuantityWarningState
}) => {
  const [renderSpecs, setRenderSpecs] = useState(false);
  const [isSpecsOpen, setIsSpecsOpen] = useState(false);

  return (
    <>
      <PromoQuickviewSectionCta
        setOpen={setIsSpecsOpen}
        setRender={setRenderSpecs}
        clickAnalytics={onSectionClick}
        sectionName="Specs"
      />

      {renderSpecs && (
        <PromoSidecar
          isSidecarOpen={isSpecsOpen}
          setIsSidecarOpen={setIsSpecsOpen}
          zIndex={1000}
          backText="Back to Quick View"
          itemId={itemId}
          useSidecarNav
          useSidecarCta
          selected={selected}
          onSelect={onSelect}
          setQuantityWarningText={setQuantityWarningText}
          showQuantityWarningState={showQuantityWarningState}
        >
          <article className="promo-quickview-section-sidecar">
            <Specifications itemId={itemId} storeId={storeId} hideMobileFade />
          </article>
        </PromoSidecar>
      )}
    </>
  );
};

PromoQuickviewSpecs.displayName = 'PromoQuickviewSpecs';

PromoQuickviewSpecs.propTypes = {
  itemId: string.isRequired,
  storeId: string.isRequired,
  onSectionClick: func,
  selected: bool.isRequired,
  onSelect: func.isRequired,
  setQuantityWarningText: func,
  showQuantityWarningState: bool
};

PromoQuickviewSpecs.defaultProps = {
  onSectionClick: noop,
  setQuantityWarningText: noop,
  showQuantityWarningState: false
};

PromoQuickviewSpecs.dataModel = extend({}, Specifications);